import { Component, OnInit } from '@angular/core';
import {RoleService} from '../../services/role.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-loads',
  templateUrl: './loads.component.html',
  styleUrls: ['./loads.component.css']
})
export class LoadsComponent implements OnInit {

  constructor(
    private roleService: RoleService,
    private router: Router,
  ) { }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  currentUserIsCompliance(): boolean {
 return this.roleService.hasRoles('compliance') || this.roleService.hasRoles('compliance_manager');
}

  ngOnInit() {

    this.router.navigate(['/loads/btl']);

  }

}
